export class OrderEntry_NewModel {
setValue(res){
if(res){
}
}
}